import React from "react";
import embededCode from "./embeded-code";
import MobilePreview from "storybookComponents/MobilePreview";
import Icon from "storybookComponents/Icon"
import { IconButton } from "@material-ui/core";
import emailShareCode from "./email-popup-embed-code";
import EmailPreview from "../emailPreview"
import smsShareCode from "./sms-popup-embed-code";
import fbShareCode from "./fb-popup-embed-code";
import twitterShareCode from "./twitter-popup-embed-code";
import thanksShareCode from "./thanks-popup-embed-code";
import { smsPreviewHtml, linkify } from "../../utils/index";
import SwipeableViews from "react-swipeable-views";
import LeftButtonsMenu from "../leftmenu";

import "./style.css";

const Arrow = ({ show, icon, onClick }) => (
  <div style={{ width: 70 }}>
    {
      show &&
      <IconButton onClick={onClick}>
        <Icon type={icon} size="xl" style={{ color: "black" }} />
      </IconButton>
    }
  </div>
)

const WebPreview = ({ html }) => <iframe id="hylyEnrollForm" srcDoc={html} scrolling="no" style={{ width: "100%", border: "none", height: "100vh" }} />

const Container = ({ mobile, children }) => <div style={{ width: mobile ? 380 : 600, margin: "auto" }}> {children} </div>

const options = [{
  id: 1,
  name: "1. Share Options",
}, {
  id: 2,
  name: "2. Share Previews (5)"
}]

export default ({ index, mobileView, smsView, viewShareOptions, ...props }) => {
  const prevews = {
    0: thanksShareCode(props.reward, props.tourCtaUrl, props)
  }
  if (index == 1) {
    return <EmailPreview
      {...props}
      mobileView={mobileView}
      smsView={smsView}
    />
  }

  return (
    <>
      <div className="hyraf-enroll-form-container">
        {
          mobileView ?
            <>
              <Container mobile>
                <SwipeableViews index={index} animateTransitions={false}>
                  <MobilePreview id="p0" html={embededCode(props)} extraMargin={200} />
                  <MobilePreview id="p1" html={prevews[0]} extraMargin={200} />
                  <MobilePreview id="p2" html={prevews[0]} extraMargin={200} />
                </SwipeableViews>
              </Container>
            </>
            : <Container>
              <SwipeableViews index={index} animateTransitions={false}>
                <WebPreview id="p0" html={embededCode(props)} />
                <WebPreview id="p1" html={prevews[0]} />
                <WebPreview id="p2" html={prevews[0]} />
              </SwipeableViews>
            </Container>
        }
      </div >
    </>
  )
}